import {safeText} from "../../js/util/CommonUtils.js";

export default class TooltipManagerHtml{
    /** @type {HTMLElement} */
    #parent;
    /** @type {HTMLElement} */
    #element;
    /** @type {function} */
    #onCloseCb;

    /** @param {HTMLElement} parent */
    init(parent){
        this.#parent = parent
    }

    /** @param {{name: string, data: {tooltipText: string, nextDate: Date}}} tooltipData */
    show(tooltipData){
        this.#parent.insertAdjacentHTML('beforeend', this.#template(tooltipData.data.tooltipText));
        this.#element = this.#parent.lastElementChild;
        const closeIcon = this.#parent.querySelector('[data-action="close"]');
        closeIcon.addEventListener('click', this.#delete.bind(this, tooltipData));
    }

    /** @param {function} cb */
    onClose(cb){
        this.#onCloseCb = cb
    }

    #delete(tooltipData){
        this.#onCloseCb(tooltipData)
        this.#element.remove()
    }

    /**
     * @param {string} text
     * @returns {string}
     */
    #template(text){
        return `
        <div class="tooltip">
            <div class="tooltip-container">
                <div class="tooltip__text">${safeText(text)}</div>
                <span data-action="close" class="material-icons tooltip__close-icon">close</span>
            </div>
        </div>
        `
    }
}